import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../../../modals/ModalComponent.jsx";
import moment from "moment/moment.js";
import { MarkAsReadNotificationApi } from "../../../../api/request/notification.js";
import { Spin } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const Notifications = ({
  notifications,
  getNotification,
  setIsNotification,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [notificationData, setNotificationData] = useState(notifications || []);
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);

  const viewNotification = (notification) => {
    setSelectedNotification(notification);
    markAsRead(notification?.id);
    setIsOpen(true);
  };

  const markAsRead = async (id) => {
    try {
      setIsNotificationLoading(true);
      const params = { notification_id: id };
      const { data } = await MarkAsReadNotificationApi(params);

      if (data?.status) {
        const updated = notificationData?.map((item) =>
          item?.id === id ? { ...item, is_read: true } : item
        );
        setNotificationData(updated);
        getNotification();
      }
    } catch (error) {
      console.error("Error marking as read:", error);
    } finally {
      setIsNotificationLoading(false);
    }
  };

  useEffect(() => {
    setNotificationData(notifications);
  }, [notifications]);

  const navigateNotification = [
    { label: "files", path: "/files" },
    { label: "chat", path: "/chat" },
    { label: "payment", path: "/dashboard" },
    { label: "signature", path: "/dashboard" },
    { label: "dashboard", path: "/dashboard" },
    { label: "invoice", path: "/dashboard" },
  ];

  const handleModalClick = () => {
    if (!selectedNotification?.notify_type) return;

    const matched = navigateNotification?.find(
      (item) => item?.label === selectedNotification?.notify_type
    );

    if (matched) {
      setIsOpen(false);
      setIsNotification(false);
      navigate(matched?.path);
    }
  };

  return (
    <div>
      {isLoading || isNotificationLoading ? (
        <div className="flex justify-center items-center h-[60vh]">
          <Spin size="large" />
        </div>
      ) : notificationData?.length > 0 ? (
        <div>
          {notificationData?.map((item, index) => (
            <div
              className={`relative flex items-center gap-4 border rounded-lg p-5 cursor-pointer my-2 transition-all duration-200 ${
                item?.is_read ? "bg-white" : "bg-primaryLight"
              }`}
              key={index}
              onClick={() => viewNotification(item)}
            >
              <div className="absolute top-1 right-1 py-0.5 px-1 rounded-full hover:bg-gray-100 transition-colors">
                <CloseOutlined
                  className="text-gray-400 hover:text-gray-600 text-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    markAsRead(item?.id);
                  }}
                />
              </div>

              <div className="w-full">
                <div className="flex justify-between items-center w-full">
                  <p className="font-semibold text-base line-clamp-1 w-2/3">
                    {item?.title}
                  </p>
                  <p className="text-sm text-gray-400">
                    {moment(item?.created_at).fromNow()}
                  </p>
                </div>
                <p className="mt-1 text-gray-500 line-clamp-1">
                  {item?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-12">
          <p className="text-gray-400 text-center title">No Notification</p>
        </div>
      )}

      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Notification"
        width={800}
      >
        {selectedNotification && (
          <div
            className="cursor-pointer"
            onClick={() => handleModalClick()}
          >
            <div className="flex justify-between items-center w-full mb-4">
              <p className="title">{selectedNotification?.title}</p>
              <p className="text-sm text-gray-400 text-right">
                {moment(selectedNotification?.createdDate).fromNow()}
              </p>
            </div>
            <p className="text-lg">{selectedNotification?.description}</p>
          </div>
        )}
      </ModalComponent>
    </div>
  );
};

export default Notifications;
